import React, { Component } from 'react';
import Button from '../utility/Button';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { postKmiForm, postRecaptcha } from '../../actions/reviews';
import { Link, withRouter } from 'react-router-dom';
import Cookies from 'js-cookie';
import states from '../../locales/en/states.json';
// import Recaptcha from 'react-google-invisible-recaptcha';
import ReCAPTCHA from 'react-google-recaptcha';

class KeepMeInform extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone_num: '',
      state_city: '',
      preferred_trip: this.props.preferredTrip,
      site_key: '6LdbVSYjAAAAAAT_e6LxJMx_v7w4wuGl3cG7JB6N',//process.env.MIX_SITE_KEY
      messageSent: false,
      received: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  // recaptcha v2
  async handleOnChange(value){
    if(value){
      console.log('recaptcha value: ', value);
      const xsrf = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
      const response_token = value;
      const recaptcha_data = { 'response': response_token };
      const response = await postRecaptcha(recaptcha_data, xsrf);

      if(response.success === true)
        this.setState({messageSent: true});
    }
    else
      this.setState({messageSent: false});
  }

  // recaptcha v3
  // sendMessage = () => {
  //   this.recaptcha.execute();
  // }
  // onResolved = () => {
  //   const secret_key = "6Lcq-SAjAAAAAJcFbCCUpxvyqadI8rYrQiWhFRct";
  //   const response_token = this.recaptcha.getResponse();
  //   const recaptcha_data = { "secret": secret_key, "response": response_token };
  //   const response = postRecaptcha(recaptcha_data);

  //   console.log(recaptcha_data);
  //   console.log(response);
  //   this.setState({messageSent: true});
  // }

  resetForm(){
    this.setState({received: false, name: '', email: '', phone_num: '', state_city: '', preferred_trip: '', messageSent: false});
  }

  async handleSubmit(event) {
    event.preventDefault();

    // submit form to API
    const xsrf = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
    const response = await postKmiForm(this.state, xsrf);
    event.preventDefault();
    if (response.status === 'success'){
      this.setState({received: true});
    }
    else if (response.status === 'failed'){
      alert(response.message);
    }else{
      alert('Something went wrong. Could not submit the form');
    }
  }

  render() {
    const { name, email, phone_num, state_city} = this.state;
    const { t, togglePopUpKmi, preferredTrip } = this.props;


    return(
      <div className='container fe-kmi-container'>
        <div className='fe-kmi-close d-flex justify-content-end'>
          <button className='fe-kmi-close-btn' onClick={() => {togglePopUpKmi(false); this.resetForm();}}></button>
        </div>
        {(this.state.received) ? (
          <div className='container fe-kmi-header-container'>
            <header className='fe-kmi-header received'>
              <h1 className='fe-kmi-header-heading'>Thank you!</h1>
              <h4 className='fe-kmi-header-heading'>We’ll be in touch as soon as there is an update.</h4>
            </header>
          </div>
        ) : (
          <>
            <div className='container fe-kmi-header-container'>
              <header className='fe-kmi-header'>
                <h1 className='fe-kmi-header-heading'>{t('form:kmiHeaderTitle')}</h1>
                <h4 className='fe-kmi-header-heading'>{t('form:kmiHeaderDescription')}</h4>
              </header>
            </div>
            <div className='fe-kmi-form-container'>
              <form
                id="fe-contact-form"
                onSubmit={this.handleSubmit}
                className="fe-contact-form"
              >
                <input id="preferred_trip" name="preferred_trip" type="text" value={preferredTrip} hidden />
                <div className="fe-kmi-form-field">
                  <input id="name" name="name" type="text" value={name} onChange={this.handleChange} placeholder={t('form:name')} required />
                </div>
                <div className="fe-kmi-form-field">
                  <input id="phone_num" name="phone_num" type="tel" value={phone_num} onChange={this.handleChange} placeholder={t('form:phone')} pattern="[0-9]{9,11}" required />
                </div>
                <div className="fe-kmi-form-field">
                  <input id="email" name="email" type="email" value={email} onChange={this.handleChange} placeholder={t('form:email')} pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" required />
                </div>
                <div className="fe-kmi-form-field">
                  <select
                    className="fe-u-select custom-select"
                    id="states"
                    name="state_city"
                    required
                    value={state_city}
                    onChange={this.handleChange}
                  >
                    <option value='' disabled>State</option>
                    {Object.entries(states).map(([key,value]) => <option key={key} value={value}>{value}</option>) }
                  </select>
                </div>
                <div className="fe-kmi-form-field-user-consent align-items-center">
                  <div className="m-1">
                    <input id="user_consent" name="user_consent" type="checkbox" value={1} onChange={this.handleChange} required />
                  </div>
                  <div className="m-1">
                    <p className="m-auto">{t('form:userConsent')} <Link to="/privacy-disclaimer/" target="_blank">Privacy and Disclaimer Policy</Link>.</p>
                  </div>
                </div>
                {/* <button onClick={this.sendMessage}>recaptcha</button> */}
                {/* <Recaptcha
                  ref={ ref => this.recaptcha = ref}
                  sitekey="6Lcq-SAjAAAAAAGLUZw12w76FFYs63XuJBQJAcCG"
                  onResolved={ this.onResolved }
                /> */}
                <div className="fe-kmi-form-field">
                  <ReCAPTCHA
                    className="g-recaptcha"
                    sitekey={this.state.site_key}
                    onChange={this.handleOnChange}
                  />
                </div>
                <div className="fe-kmi-form-field submit">
                  <Button type="submit" className="fe-kmi-submit-btn" disabled={!this.state.messageSent} showLoader={false}>
                    {t('form:submit')}
                  </Button>
                </div>
              </form>
            </div>
          </>
        )}
      </div>
    );
  }
}

KeepMeInform.propTypes = {
  history: PropTypes.object.isRequired,
  togglePopUpKmi: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  preferredTrip: PropTypes.string,
};

export default withRouter(withTranslation()(KeepMeInform));

